import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './font-heading.module.scss';
import {IconWithTooltip} from '@Components/icon-with-tooltip/icon-with-tooltip';
import {TOOLTIP_POSITION} from '@Components/tooltip';

interface FontHeadingProps {
  className?: string;
  heading: string;
  showPremiumIcon?: boolean;
}

const TOOLTIP_OFFSET_X = -95;
const TOOLTIP_OFFSET_Y = 6;

export function FontHeading({className = '', showPremiumIcon = false, ...props}: FontHeadingProps): ReactElement<any> {
  return (
    <div className={`${styles.fontHeading} flex-row-justify-between`}>
      <Text val={props.heading} className={className} size={TextSize.XSMALL} bold />
      {showPremiumIcon ? (
        <IconWithTooltip
          tooltipText={window.i18next.t('pmwjs_don’t_see_a_font')}
          icon="icon-crown"
          size={IconSize.SIZE_ICON_20}
          className={styles.icon}
          offset={{x: TOOLTIP_OFFSET_X, y: TOOLTIP_OFFSET_Y}}
          arrowPosition={TOOLTIP_POSITION.BOTTOM_RIGHT}
        />
      ) : null}
    </div>
  );
}
